/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule, LazyloadService } from '@dm/core';

import { CreateFileShareModule } from '../../file-system/create-file-share/create-file-share.module';
import { CifsShareComponent } from './cifs-share.component';
import { CifsShareService } from './cifs-share.service';
import { CifsShareStrService } from './cifs-share-str.service';
import { CreateCifsHomedirModule } from './create-cifs-homedir/create-cifs-homedir.module';
import { CreateCifsShareModule } from './create-cifs-share/create-cifs-share.module';
import { DeleteCifsShareModule } from './delete-cifs-share/delete-cifs-share.module';
import { DetailCifsShareModule } from './detail-cifs-share/detail-cifs-share.module';
import { ModifyCifsShareModule } from './modify-cifs-share/modify-cifs-share.module';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        CreateFileShareModule,
        CreateCifsShareModule,
        CreateCifsHomedirModule,
        DeleteCifsShareModule,
        ModifyCifsShareModule,
        DetailCifsShareModule,
    ],
    declarations: [CifsShareComponent],
    exports: [CifsShareComponent],
    providers: [
        LazyloadService,
        CifsShareStrService,
        CifsShareService,
    ],
})
export class CifsShareModule { }
